import { DashboardContainer } from "../base_components/dashboard_container";
import { AdminEntityViewer } from "./admin_entity_viewer";
import { AdminLogsViewer } from "./admin_logs_viewer";
import { AdminSeshStats } from "./admin_sesh_stats_viewer";
import { AdminStatusPage } from "./admin_status_page";
import { AdminStripeManager } from "./admin_stripe_manager";
import { AdminWaitlistManager } from "./admin_waitlist_manager";
import { AdminShardsViewer } from "./admin_shards_viewer";
import { AdminBlurbManager } from "./admin_blurb_manager";
import { AdminBulkDeleteEvents } from "./admin_bulk_delete_events";
import { AdminDeleteUserData } from "./admin_delete_user_data";
import { trpc } from "../../../utils/trpc";
import { DashboardUtils } from "../../../dashboard_utils";
import { useHistory } from "react-router-dom";

function AdminSubPageWrapper({ children, title }: { children: React.ReactNode; title: string }) {
	const is_admin_query = trpc.admin.isSeshAdmin.useQuery();
	const history = useHistory();

	if (is_admin_query.isError) {
		return (
			<DashboardUtils.RenderDashboardErrorPage
				text="Must be admin to view this page"
				title="UNAUTHORIZED"
			/>
		);
	}

	if (!is_admin_query.isSuccess) {
		return <DashboardUtils.RenderFullLoadingThrobberPage />;
	}

	return (
		<DashboardContainer title={title}>
			<button
				onClick={() => history.push("/dashboard/admin")}
				className="mb-6 text-blue-400 hover:text-blue-300 flex items-center gap-2"
			>
				<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
				</svg>
				Back to Admin Dashboard
			</button>
			{children}
		</DashboardContainer>
	);
}

export function AdminEntitiesPage() {
	return (
		<AdminSubPageWrapper title="Admin - Entities">
			<AdminEntityViewer />
		</AdminSubPageWrapper>
	);
}

export function AdminStripePage() {
	return (
		<AdminSubPageWrapper title="Admin - Stripe">
			<AdminStripeManager />
		</AdminSubPageWrapper>
	);
}

export function AdminStatusPageWrapper() {
	return (
		<AdminSubPageWrapper title="Admin - Status">
			<AdminStatusPage />
		</AdminSubPageWrapper>
	);
}

export function AdminWaitlistPage() {
	return (
		<AdminSubPageWrapper title="Admin - Waitlist">
			<AdminWaitlistManager />
		</AdminSubPageWrapper>
	);
}

export function AdminLogsPage() {
	return (
		<AdminSubPageWrapper title="Admin - Logs">
			<AdminLogsViewer />
		</AdminSubPageWrapper>
	);
}

export function AdminStatsPage() {
	return (
		<AdminSubPageWrapper title="Admin - Stats">
			<AdminSeshStats />
		</AdminSubPageWrapper>
	);
}

export function AdminShardsPage() {
	return (
		<AdminSubPageWrapper title="Admin - Shards">
			<AdminShardsViewer />
		</AdminSubPageWrapper>
	);
}

export function AdminBlurbsPage() {
	return (
		<AdminSubPageWrapper title="Admin - Blurbs">
			<AdminBlurbManager />
		</AdminSubPageWrapper>
	);
}

export function AdminBulkDeleteEventsPage() {
	return (
		<AdminSubPageWrapper title="Admin - Bulk Delete Events">
			<AdminBulkDeleteEvents />
		</AdminSubPageWrapper>
	);
}

export function AdminDeleteUserDataPage() {
	return (
		<AdminSubPageWrapper title="Admin - Delete User Data">
			<AdminDeleteUserData />
		</AdminSubPageWrapper>
	);
}
